import moment from 'moment'

export default value => {
  const birthday = moment(value)
  return Math.abs(birthday.diff(moment(), 'years'))
}
